import API from "../api/apiUser";

export const UserMusicService = {
    /**
     * Fetches all active music releases for the public discography page.
     * @returns {Promise<Array>} List of active music objects.
     */
    getAllMusic: async () => {
        try {
            const response = await API.get("/user/music");
            return response.data;
        } catch (error) {
            console.error("Error fetching discography:", error);
            throw error;
        }
    },

    /**
     * Fetches details of a specific music release.
     * @param {string} id - The music ID.
     * @returns {Promise<Object>} Music details object.
     */
    getMusicById: async (id) => {
        try {
            const response = await API.get(`/user/music/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching music details for ID ${id}:`, error);
            throw error;
        }
    },

    /**
     * Fetches global music page settings (streaming links).
     * @returns {Promise<Object>} Music settings object.
     */
    getMusicSettings: async () => {
        try {
            const response = await API.get("/user/music/settings");
            return response.data;
        } catch (error) {
            console.error("Error fetching music settings:", error);
            throw error;
        }
    }
};
